import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import * as S from './styles';

const msgs = defineMessages({
  cta: {
    id: 'condensed_plans_cta_unlock',
    defaultMessage: 'Unlock Pro now',
  },
  trustCancel: {
    id: 'new_plans_panel_trust_cancel',
    defaultMessage: 'Cancel anytime',
  },
  trustSecure: {
    id: 'new_plans_panel_trust_secure',
    defaultMessage: 'Secure checkout',
  },
  trustRenew: {
    id: 'new_plans_panel_trust_renew',
    defaultMessage: 'Auto-renews yearly',
  },
});

export const MobileStickyBar: FC<{ onSubscribe: () => void }> = ({ onSubscribe }) => {
  const intl = useIntl();

  return (
    <S.Container data-testid="mobile-sticky-bar">
      <S.Cta onClick={() => onSubscribe()} data-testid="mobile-cta">
        {intl.formatMessage(msgs.cta)}
      </S.Cta>
      <S.TrustRow>
        <span>{intl.formatMessage(msgs.trustCancel)}</span>
        <span>{intl.formatMessage(msgs.trustSecure)}</span>
        <span>{intl.formatMessage(msgs.trustRenew)}</span>
      </S.TrustRow>
    </S.Container>
  );
};
